import React, { Component } from 'react'

import { connect } from 'react-redux';
import {bindActionCreators} from "redux";

import {strings, CCButton, CCActions, AddCoins,CCModalLayout} from './../../cc-imports'
import {Constants} from "../../config";
import DreamTeamEntryCreation from "../../screens/DreamTeamEntryCreation/DreamTeamEntryCreation";
import SignIn from "../../screens/SignIn/SignIn";


class AddCoinsModal extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.initialState = {
            screen : 'addCoin'
        }

        this.state = this.initialState;

        this._closeModal=this._closeModal.bind(this);
        this._onModalHide=this._onModalHide.bind(this);
        this._changeScreen=this._changeScreen.bind(this);
        // this._getLeague=this._getLeague.bind(this);
    }



    _closeModal() {
        this.props.actions.closeModal("AddCoinsModal");
    }

    _onModalHide(){
        this.setState(this.initialState, ()=>{
            this._closeModal();
        });
    }

    _changeScreen(screen){
        this.setState({screen})
    }

    componentDidMount(){

    }

    render() {
        return (
            <CCModalLayout name={"AddCoinsModal"}>
               <div>
                   <AddCoins style={{margin:5}}></AddCoins>
                   <div style={{alignItems:'center', justifyContent:'center'}}>
                       <CCButton style={{width:'80%'}} title={strings('close')} onPress={this._closeModal}></CCButton>
                   </div>
               </div>
            </CCModalLayout>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user : state.user.user
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(AddCoinsModal);


// WEBPACK FOOTER //
// ./src/app/modals/AddCoinsModal/AddCoinsModal.js